<mat-card class="card">
  <mat-card-content>
    <h1>Praxis Informationen</h1>
    <h3>Name der Praixs</h3>
    <p>{{ officeService.office()?.name }}</p>
    <h3>Kontaktdaten der Praixs</h3>
    <p>{{ officeService.office()?.contactData }}</p>
    <br />
    <br />
    <!-- <pre>{{ authService.userCredential() | json }}</pre> -->

    <div class="buttons">
      <button mat-raised-button color="primary" routerLink="/patients">Patienten Liste</button>
      <button mat-raised-button color="primary" routerLink="/auth" (click)="logout()">Logout</button>
      <!-- <button mat-raised-button color="primary" routerLink="/test">Test Zugriff-Restriktionen</button> -->
    </div>
    <br />
    <br />
    <hr />
    <br />
    <p><i>Aktuell angemeldeter Benutzer: </i> {{ authService.userCredential()?.user?.email }}</p>
  </mat-card-content>
</mat-card>
